import {
  COURSE_ENROLLMENT_REQUESTED,
  COURSE_ENROLLMENT_SUCCESSFUL,
  COURSE_ENROLLMENT_FAILED,
  COURSE_BUNDLE_ENROLLMENT_REQUESTED,
  COURSE_BUNDLE_ENROLLMENT_SUCCESSFUL,
  COURSE_BUNDLE_ENROLLMENT_FAILED,
  TOGGLE_RESPONSE_MODAL,
  UNTOGGLE_RESPONSE_MODAL,
  GET_USER_PROFILE_REQUESTED,
  GET_USER_PROFILE_SUCCESSFUL,
  GET_USER_PROFILE_FAILED,
  GET_USER_NOTIFICATIONS_REQUESTED,
  GET_USER_NOTIFICATIONS_SUCCESSFUL,
  GET_USER_NOTIFICATIONS_FAILED,
  SET_USER_NOTIFICATIONS,
  SET_USER_PROFILE,
  GET_USER_ENROLLMENTS_REQUESTED,
  GET_USER_ENROLLMENTS_SUCCESSFUL,
  GET_USER_ENROLLMENTS_FAILED,
  GET_USER_CERTIFICATES_REQUESTED,
  GET_USER_CERTIFICATES_SUCCESSFUL,
  GET_USER_CERTIFICATES_FAILED,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  START_COURSE_REQUESTED,
  START_COURSE_SUCCESSFUL,
  START_COURSE_FAILED,
  END_COURSE_REQUESTED,
  END_COURSE_SUCCESSFUL,
  END_COURSE_FAILED,
  GET_USER_COURSEWARES_REQUESTED,
  GET_USER_COURSEWARES_SUCCESSFUL,
  GET_USER_COURSEWARES_FAILED,
  GET_ENROLLMENTS_REQUESTED,
  GET_ENROLLMENTS_SUCCESSFUL,
  GET_ENROLLMENTS_FAILED,
  PATCH_NOTES_REQUESTED,
  PATCH_NOTES_SUCCESSFUL,
  PATCH_NOTES_FAILED,
  SHOW_TOAST,
  COMPLETE_COURSEWARE_REQUESTED,
  COMPLETE_COURSEWARE_SUCCESSFUL,
  COMPLETE_COURSEWARE_FAILED,
  SET_COURSEWARE_PROGRESS_REQUESTED,
  SET_COURSEWARE_PROGRESS_SUCCESSFUL,
  SET_COURSEWARE_PROGRESS_FAILED,
  GET_KYC_ID_TEMPLATE_REQUESTED,
  GET_KYC_ID_TEMPLATE_SUCCESSFUL,
  GET_KYC_ID_TEMPLATE_FAILED,
  UPLOAD_KYC_ID_TEMPLATE_REQUESTED,
  UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL,
  UPLOAD_KYC_ID_TEMPLATE_FAILED,
  SET_USER_ERROR,
  START_EXAM_REQUESTED,
  START_EXAM_SUCCESSFUL,
  START_EXAM_FAILED,
  SUBMIT_ANSWER_REQUESTED,
  SUBMIT_ANSWER_SUCCESSFUL,
  SUBMIT_ANSWER_FAILED,
  GET_EXAM_DETAILS_REQUESTED,
  GET_EXAM_DETAILS_SUCCESSFUL,
  GET_EXAM_DETAILS_FAILED,
  GET_CLASS_SCHEDULE_REQUESTED,
  GET_CLASS_SCHEDULE_SUCCESSFUL,
  GET_CLASS_SCHEDULE_FAILED,
  GET_COUNTRY_CODE_REQUESTED,
  GET_COUNTRY_CODE_SUCCESSFUL,
  GET_COUNTRY_CODE_FAILED,
  TOGGLE_JOIN_CLASS,
  PAID_COURSE_ENROLLMENT_REQUESTED,
  PAID_COURSE_ENROLLMENT_SUCCESSFUL,
  PAID_COURSE_ENROLLMENT_FAILED,
  GET_DRAGONPAY_PROCESSORS_REQUESTED,
  GET_DRAGONPAY_PROCESSORS_SUCCESSFUL,
  GET_DRAGONPAY_PROCESSORS_FAILED,
  SHOW_CONFIRM_MODAL,
  HIDE_CONFIRM_MODAL,
  SET_EXAM_AS_SUBMITTED,
  GET_MCLE_PROFILE_REQUEST,
  GET_MCLE_PROFILE_SUCCESS,
  GET_MCLE_PROFILE_FAILED,
  SET_MCLE_USER_PROFILE,
  UPDATE_MCLE_PROFILE_REQUEST,
  UPDATE_MCLE_PROFILE_SUCCESS,
  UPDATE_MCLE_PROFILE_FAILED,
  GET_LAW_SCHOOLS_REQUEST,
  GET_LAW_SCHOOLS_SUCCESS,
  GET_LAW_SCHOOLS_FAILED,
  SUBMIT_MANUAL_KYC_REQUESTED,
  SUBMIT_MANUAL_KYC_SUCCESSFUL,
  SUBMIT_MANUAL_KYC_FAILED,
  SET_KYC_VERIFY_RETRIES,
  PAID_BUNDLE_ENROLLMENT_REQUESTED,
  PAID_BUNDLE_ENROLLMENT_SUCCESSFUL,
  PAID_BUNDLE_ENROLLMENT_FAILED,
  UPDATE_PROFILE_PHOTO_REQUESTED,
  UPDATE_PROFILE_PHOTO_SUCCESSFUL,
  UPDATE_PROFILE_PHOTO_FAILED,
  SHOW_PROFILE_PHOTO_MODAL,
  HIDE_PROFILE_PHOTO_MODAL,
  GET_WALLET_BALANCE_REQUESTED,
  GET_WALLET_BALANCE_SUCCESSFUL,
  GET_WALLET_BALANCE_FAILED,
  GET_WALLET_TRANSACTIONS_REQUESTED,
  GET_WALLET_TRANSACTIONS_SUCCESSFUL,
  GET_WALLET_TRANSACTIONS_FAILED,
  GET_USER_CLASSES_REQUESTED,
  GET_USER_CLASSES_SUCCESSFUL,
  GET_USER_CLASSES_FAILED,
  GET_USER_WALLET_NONCE_REQUESTED,
  GET_USER_WALLET_NONCE_SUCCESSFUL,
  GET_USER_WALLET_NONCE_FAILED,
  REGISTER_WALLET_ADDRESS_REQUESTED,
  REGISTER_WALLET_ADDRESS_SUCCESSFUL,
  REGISTER_WALLET_ADDRESS_FAILED,
  VERIFY_WALLET_ADDRESS_REQUESTED,
  VERIFY_WALLET_ADDRESS_SUCCESSFUL,
  VERIFY_WALLET_ADDRESS_FAILED,
  CLAIM_TOKENS_REQUESTED,
  CLAIM_TOKENS_SUCCESSFUL,
  CLAIM_TOKENS_FAILED,
  SET_WALLET_CONNECTED,
  SET_VERIFYING_ADDRESS,
  GET_PH_REGIONS_REQUESTED,
  GET_PH_REGIONS_SUCCESSFUL,
  GET_PH_REGIONS_FAILED,
  GET_IBP_CHAPTERS_REQUESTED,
  GET_IBP_CHAPTERS_SUCCESSFUL,
  GET_IBP_CHAPTERS_FAILED,
  GET_COMPLIANCE_PERIOD_REQUESTED,
  GET_COMPLIANCE_PERIOD_SUCCESSFUL,
  GET_COMPLIANCE_PERIOD_FAILED,
  SET_SHOW_IDLE_MODAL,
  START_INACTIVITY_TIMEOUT,
  STOP_INACTIVITY_TIMEOUT,
} from "./action-types"

export const getUserProfile = ({ userId, role }) => {
  let userType = role === "ST" ? "students" : "users"
  return {
    types: [
      GET_USER_PROFILE_REQUESTED,
      GET_USER_PROFILE_SUCCESSFUL,
      GET_USER_PROFILE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/${userType}/${userId}/`,
      },
    },
  }
}

export const getUserEnrollments = ({ userId, data }) => {
  let queryStr = []
  queryStr = Object.values(data).join("&")

  return {
    types: [
      GET_USER_ENROLLMENTS_REQUESTED,
      GET_USER_ENROLLMENTS_SUCCESSFUL,
      GET_USER_ENROLLMENTS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/students/${userId}/enrollments/?${queryStr}`,
      },
    },
  }
}

export const getUserCertificates = ({ userId, data }) => {
  let queryStr = []
  queryStr = Object.values(data).join("&")

  return {
    types: [
      GET_USER_CERTIFICATES_REQUESTED,
      GET_USER_CERTIFICATES_SUCCESSFUL,
      GET_USER_CERTIFICATES_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/students/${userId}/certificates/?${queryStr}`,
      },
    },
  }
}

export const getUserNotifications = ({ page = 1 }) => {
  return {
    types: [
      GET_USER_NOTIFICATIONS_REQUESTED,
      GET_USER_NOTIFICATIONS_SUCCESSFUL,
      GET_USER_NOTIFICATIONS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/notifications/?page=${page}`,
      },
    },
  }
}

export const setUserNotifications = (payload) => {
  return {
    type: SET_USER_NOTIFICATIONS,
    payload,
  }
}

export const courseEnrollment = (data) => {
  return {
    types: [
      COURSE_ENROLLMENT_REQUESTED,
      COURSE_ENROLLMENT_SUCCESSFUL,
      COURSE_ENROLLMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/student/enrollment/`,
        data,
      },
    },
  }
}

export const courseBundleEnrollment = (data) => {
  return {
    types: [
      COURSE_BUNDLE_ENROLLMENT_REQUESTED,
      COURSE_BUNDLE_ENROLLMENT_SUCCESSFUL,
      COURSE_BUNDLE_ENROLLMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/enrollment/bundle/`,
        data,
      },
    },
  }
}

export const showResponseModal = (payload) => {
  return {
    type: TOGGLE_RESPONSE_MODAL,
    payload,
  }
}

export const closeResponseModal = (payload) => {
  return {
    type: UNTOGGLE_RESPONSE_MODAL,
    payload,
  }
}

export const setUserProfile = (payload) => {
  return {
    type: SET_USER_PROFILE,
    payload,
  }
}

export const updateProfile = ({ id, data, role }) => {
  let userType = role === "ST" ? "students" : "users"
  return {
    types: [
      UPDATE_PROFILE_REQUEST,
      UPDATE_PROFILE_SUCCESS,
      UPDATE_PROFILE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "PUT",
        url: `/${userType}/${id}/`,
        data,
      },
    },
  }
}

export const updateProfilePhoto = (id, data) => {
  return {
    types: [
      UPDATE_PROFILE_PHOTO_REQUESTED,
      UPDATE_PROFILE_PHOTO_SUCCESSFUL,
      UPDATE_PROFILE_PHOTO_FAILED,
    ],
    payload: {
      auth: true,
      multipartform: true,
      request: {
        method: "PATCH",
        url: `/users/${id}/`,
        data,
      },
    },
  }
}

export const showProfilePhotoModal = (payload) => {
  return {
    type: SHOW_PROFILE_PHOTO_MODAL,
    payload,
  }
}

export const hideProfilePhotoModal = (payload) => {
  return {
    type: HIDE_PROFILE_PHOTO_MODAL,
    payload,
  }
}

export const getLawSchools = () => {
  return {
    types: [
      GET_LAW_SCHOOLS_REQUEST,
      GET_LAW_SCHOOLS_SUCCESS,
      GET_LAW_SCHOOLS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/law_schools/`,
      },
    },
  }
}

export const setMCLEProfile = (payload) => {
  return {
    type: SET_MCLE_USER_PROFILE,
    payload,
  }
}

export const getMCLEProfile = ({ id }) => {
  return {
    types: [
      GET_MCLE_PROFILE_REQUEST,
      GET_MCLE_PROFILE_SUCCESS,
      GET_MCLE_PROFILE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/students/${id}/mcle_profile/`,
      },
    },
  }
}

export const updateMCLEProfile = ({ id, data }) => {
  return {
    types: [
      UPDATE_MCLE_PROFILE_REQUEST,
      UPDATE_MCLE_PROFILE_SUCCESS,
      UPDATE_MCLE_PROFILE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "PUT",
        url: `/students/${id}/mcle_profile/`,
        data,
      },
    },
  }
}

export const startCourse = ({ id }) => {
  return {
    types: [
      START_COURSE_REQUESTED,
      START_COURSE_SUCCESSFUL,
      START_COURSE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/courses/${id}/start/`,
      },
    },
  }
}

export const endCourse = ({ id }) => {
  return {
    types: [END_COURSE_REQUESTED, END_COURSE_SUCCESSFUL, END_COURSE_FAILED],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/courses/${id}/end/`,
      },
    },
  }
}

export const getCoursewareById = ({ id }) => {
  return {
    types: [
      GET_USER_COURSEWARES_REQUESTED,
      GET_USER_COURSEWARES_SUCCESSFUL,
      GET_USER_COURSEWARES_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/coursewares/${id}/`,
      },
    },
  }
}

export const getEnrollments = () => {
  return {
    types: [
      GET_ENROLLMENTS_REQUESTED,
      GET_ENROLLMENTS_SUCCESSFUL,
      GET_ENROLLMENTS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/enrollments/`,
      },
    },
  }
}

export const patchNotes = ({ id, data }) => {
  return {
    types: [PATCH_NOTES_REQUESTED, PATCH_NOTES_SUCCESSFUL, PATCH_NOTES_FAILED],
    payload: {
      auth: true,
      request: {
        method: "PATCH",
        url: `/enrollments/${id}/`,
        data,
      },
    },
  }
}

export const showToast = (payload) => {
  return {
    type: SHOW_TOAST,
    payload,
  }
}

export const completeCourseware = ({ id }) => {
  return {
    types: [
      COMPLETE_COURSEWARE_REQUESTED,
      COMPLETE_COURSEWARE_SUCCESSFUL,
      COMPLETE_COURSEWARE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/coursewares/${id}/complete/`,
      },
    },
  }
}

export const saveProgress = ({ data }) => {
  return {
    types: [
      SET_COURSEWARE_PROGRESS_REQUESTED,
      SET_COURSEWARE_PROGRESS_SUCCESSFUL,
      SET_COURSEWARE_PROGRESS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/progress/`,
        data,
      },
    },
  }
}

export const getIDTemplate = () => {
  return {
    types: [
      GET_KYC_ID_TEMPLATE_REQUESTED,
      GET_KYC_ID_TEMPLATE_SUCCESSFUL,
      GET_KYC_ID_TEMPLATE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/kyc/template_ids/`,
      },
    },
  }
}

export const verifyKYCPhoto = (data) => {
  return {
    types: [
      UPLOAD_KYC_ID_TEMPLATE_REQUESTED,
      UPLOAD_KYC_ID_TEMPLATE_SUCCESSFUL,
      UPLOAD_KYC_ID_TEMPLATE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/kyc/upload/`,
        data,
      },
    },
  }
}

export const submitManualKYC = (schoolId) => {
  return {
    types: [
      SUBMIT_MANUAL_KYC_REQUESTED,
      SUBMIT_MANUAL_KYC_SUCCESSFUL,
      SUBMIT_MANUAL_KYC_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/kyc/verify/notify/`,
        data: {
          school: schoolId,
        },
      },
    },
  }
}

export const setKYCVerifyRetries = (payload) => {
  return {
    type: SET_KYC_VERIFY_RETRIES,
    payload,
  }
}

export const setUserError = (payload) => {
  return {
    type: SET_USER_ERROR,
    payload,
  }
}

export const startExam = (id) => {
  return {
    types: [START_EXAM_REQUESTED, START_EXAM_SUCCESSFUL, START_EXAM_FAILED],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/exams/${id}/start/`,
      },
    },
  }
}

export const getExamDetails = (id) => {
  return {
    types: [
      GET_EXAM_DETAILS_REQUESTED,
      GET_EXAM_DETAILS_SUCCESSFUL,
      GET_EXAM_DETAILS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/exams/${id}/`,
      },
    },
  }
}

export const getStudentClasses = (queryString = false) => {
  return {
    types: [
      GET_USER_CLASSES_REQUESTED,
      GET_USER_CLASSES_SUCCESSFUL,
      GET_USER_CLASSES_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/students/classes/?${queryString}`,
      },
    },
  }
}

export const submitAnswer = ({ id, data, isMultipart }) => {
  return {
    types: [
      SUBMIT_ANSWER_REQUESTED,
      SUBMIT_ANSWER_SUCCESSFUL,
      SUBMIT_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      multipartform: isMultipart,
      request: {
        method: "POST",
        url: `/exam/questions/${id}/submit/`,
        data,
      },
    },
  }
}

export const getClassScheduleById = (id) => {
  return {
    types: [
      GET_CLASS_SCHEDULE_REQUESTED,
      GET_CLASS_SCHEDULE_SUCCESSFUL,
      GET_CLASS_SCHEDULE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/classes/${id}/schedule/`,
      },
    },
  }
}

export const getCountryCode = (id) => {
  return {
    types: [
      GET_COUNTRY_CODE_REQUESTED,
      GET_COUNTRY_CODE_SUCCESSFUL,
      GET_COUNTRY_CODE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/countries/`,
      },
    },
  }
}

export const toggleJoinClass = (payload) => {
  return {
    type: TOGGLE_JOIN_CLASS,
    payload,
  }
}

export const paidCourseEnrollment = (data) => {
  return {
    types: [
      PAID_COURSE_ENROLLMENT_REQUESTED,
      PAID_COURSE_ENROLLMENT_SUCCESSFUL,
      PAID_COURSE_ENROLLMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/student/enrollment/`,
        data,
      },
    },
  }
}

export const paidBundleEnrollment = (data) => {
  return {
    types: [
      PAID_BUNDLE_ENROLLMENT_REQUESTED,
      PAID_BUNDLE_ENROLLMENT_SUCCESSFUL,
      PAID_BUNDLE_ENROLLMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/enrollment/bundle/`,
        data,
      },
    },
  }
}

export const getDragonpayProcessors = () => {
  return {
    types: [
      GET_DRAGONPAY_PROCESSORS_REQUESTED,
      GET_DRAGONPAY_PROCESSORS_SUCCESSFUL,
      GET_DRAGONPAY_PROCESSORS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/dragonpay/processors/`,
      },
    },
  }
}

export const getWalletBalance = () => {
  return {
    types: [
      GET_WALLET_BALANCE_REQUESTED,
      GET_WALLET_BALANCE_SUCCESSFUL,
      GET_WALLET_BALANCE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/wallets/`,
      },
    },
  }
}

export const getWalletTransactions = (params = {}) => {
  const queryString = new URLSearchParams(params).toString()

  return {
    types: [
      GET_WALLET_TRANSACTIONS_REQUESTED,
      GET_WALLET_TRANSACTIONS_SUCCESSFUL,
      GET_WALLET_TRANSACTIONS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/wallets/transactions/?${queryString}`,
      },
    },
  }
}

export const getUserWalletNonce = (params = {}) => {
  const queryString = new URLSearchParams(params).toString()

  return {
    types: [
      GET_USER_WALLET_NONCE_REQUESTED,
      GET_USER_WALLET_NONCE_SUCCESSFUL,
      GET_USER_WALLET_NONCE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/users/wallet/?${queryString}`,
      },
    },
  }
}

export const registerWalletAddress = (data) => {
  return {
    types: [
      REGISTER_WALLET_ADDRESS_REQUESTED,
      REGISTER_WALLET_ADDRESS_SUCCESSFUL,
      REGISTER_WALLET_ADDRESS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/users/wallet/`,
        data,
      },
    },
  }
}

export const verifyWalletAddress = (data) => {
  return {
    types: [
      VERIFY_WALLET_ADDRESS_REQUESTED,
      VERIFY_WALLET_ADDRESS_SUCCESSFUL,
      VERIFY_WALLET_ADDRESS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/users/wallet/verify/`,
        data,
      },
    },
  }
}

export const claimL2ETokens = (data) => {
  return {
    types: [
      CLAIM_TOKENS_REQUESTED,
      CLAIM_TOKENS_SUCCESSFUL,
      CLAIM_TOKENS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/users/wallet/transfer/`,
        data,
      },
    },
  }
}

export const setWalletConnected = (payload) => {
  return {
    type: SET_WALLET_CONNECTED,
    payload,
  }
}

export const setVerifyingAddress = (payload) => {
  return {
    type: SET_VERIFYING_ADDRESS,
    payload,
  }
}

export const showConfirmModal = (payload) => {
  return {
    type: SHOW_CONFIRM_MODAL,
    payload,
  }
}

export const closeConfirmModal = (payload) => {
  return {
    type: HIDE_CONFIRM_MODAL,
    payload,
  }
}

export const setExamAsSubmitted = (payload) => {
  return {
    type: SET_EXAM_AS_SUBMITTED,
    payload,
  }
}

export const getPHRegions = () => {
  return {
    types: [
      GET_PH_REGIONS_REQUESTED,
      GET_PH_REGIONS_SUCCESSFUL,
      GET_PH_REGIONS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/ph_regions/`,
      },
    },
  }
}

export const getIBPChapters = () => {
  return {
    types: [
      GET_IBP_CHAPTERS_REQUESTED,
      GET_IBP_CHAPTERS_SUCCESSFUL,
      GET_IBP_CHAPTERS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/ibp_chapters/`,
      },
    },
  }
}

export const getCompliancePeriod = () => {
  return {
    types: [
      GET_COMPLIANCE_PERIOD_REQUESTED,
      GET_COMPLIANCE_PERIOD_SUCCESSFUL,
      GET_COMPLIANCE_PERIOD_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/compliance_periods/`,
      },
    },
  }
}

export const startInactivityTimeout = (payload) => {
  return {
    type: START_INACTIVITY_TIMEOUT,
    payload,
  }
}

export const stopInactivityTimeout = (payload) => {
  return {
    type: STOP_INACTIVITY_TIMEOUT,
    payload,
  }
}

export const setShowIdleModal = (payload) => {
  return {
    type: SET_SHOW_IDLE_MODAL,
    payload,
  }
}
